import { Component, Input, OnInit } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faHeart,
  faRocket,
  faIdCard,
  faSlidersH,
  faUndo,
  faShoppingCart,
} from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { HeaderComponent } from '../../../shared/header/header.component';
import { FooterComponent } from '../../../shared/footer/footer.component';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StyleDirectionService } from '../../../services/style-direction.service';
import { CartService } from '../../../appshared/invoice/cart.service';
import { FormsModule } from '@angular/forms';
import {
  ItemModule,
  ViewItem,
} from '../../../appshared/invoice/item/item.module';
import { ItemService } from '../../../appshared/invoice/item/item.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ItemPictureService } from '../../../appshared/invoice/item-picture/item-picture.service';
import { ItemPictureModule } from '../../../appshared/invoice/item-picture/item-picture.module';
import { environment } from '../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-items',
  standalone: true,
  imports: [
    FontAwesomeModule,
    HeaderComponent,
    FooterComponent,
    CommonModule,
    TranslateModule,
    RouterLink,
    FormsModule,
    TranslateModule,
  ],
  templateUrl: './items.component.html',
  styleUrl: './items.component.css',
})
export class ItemsComponent implements OnInit {
  product: ItemModule | null = null;
  productDetails: string[] = [];
  mainImage: string = '';
  allproducts: ItemModule[] = [];
  totalItems: number = 1;
  itemId: number = 0;
  itemPictures: ItemPictureModule[] = [];
  ComID: number = 1;
  public apiURL: string = '';
  categoryId: number = 0;
  currentLang: string = localStorage.getItem('locale') || 'en';
  Direction: string = 'ltr';
  items: ItemModule[] = [];

  faHeart = faHeart;
  faRocket = faRocket;
  faSlidersH = faSlidersH;
  faIdCard = faIdCard;
  faUndo = faUndo;
  faShoppingCart = faShoppingCart;
  showAlert: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private itemService: ItemService,
    private itemPictureService: ItemPictureService,
    private router: Router,
    private translate: TranslateService,
    private styleDirectionService: StyleDirectionService,
    private cartService: CartService,
    private toastr: ToastrService
  ) {
    const storedLang = localStorage.getItem('locale') || 'ar';
    this.translate.setDefaultLang(storedLang);
    this.translate.use(storedLang);

    this.setDirectionAndStyles(storedLang);
  }

  setDirectionAndStyles(storedLang: string) {
    if (storedLang === 'ar') {
      this.Direction = 'rtl';
      this.styleDirectionService.fillData(true);
    } else {
      this.Direction = 'ltr';
      this.styleDirectionService.fillData(false);
    }
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.itemId = +params['id'];
      if (this.itemId) {
        this.getProductDetails();
        this.fetchItemPictures();
      }
    });
    this.apiURL =
      environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';
  }

  getProductDetails(): void {
    if (this.itemId) {
      this.itemService.getServiceID(this.itemId).subscribe(
        (response: any) => {
          console.log('API response:', response);
          if (Array.isArray(response) && response.length > 0) {
            this.product = response[0];
            this.mainImage = this.product?.photoPath || '';
            this.productDetails = this.product?.details || [];

            this.categoryId = this.product?.gnCategoryID || 0;
            this.getitemsCategory();


            if (this.product) {
              this.product.salesPrice = this.calculateDiscountedPrice(
                this.product
              );
            }
          } else if (response && typeof response === 'object') {
            this.product = response;
            this.mainImage = this.product?.photoPath || '';
            this.productDetails = this.product?.details || [];
          }



          // else {
          //   console.log('Unexpected response format or product not found');
          // }
        },
        (error: HttpErrorResponse) => {
          console.error('Error retrieving product details:', error);
        }
      );
    }
  }

  fetchItemPictures(): void {
    this.itemPictureService.getServiceID(this.itemId).subscribe(
      (pictures: ItemPictureModule[]) => {
        this.itemPictures = pictures;
      },
      (error) => {
        console.error('Error fetching item pictures:', error);
      }
    );
  }

  calculateDiscountedPrice(product: ItemModule): number {
    if (product.activateWebDiscount) {
      return  (product?.webDiscountAmount ?? 0);
    }
    return product.salesPrice ?? 0;
  }

  updateMainImage(imagePath: string): void {
    this.mainImage = imagePath;
  }

  increase(): void {
    this.totalItems++;
  }

  decrease(): void {
    if (this.totalItems > 1) {
      this.totalItems--;
    }
  }

  addToCart(): void {
    if (this.product) {
      const discountedPrice = this.calculateDiscountedPrice(this.product);
      const viewItem: ViewItem = {
        ...this.product,
        salesPrice: discountedPrice,
        cartQuantity: this.totalItems,
      };
      this.cartService.addToCart(viewItem, this.totalItems);


      if (this.currentLang === 'en') {
        this.toastr.success(`Added item ${this.product.name} to the cart.`);
      } else {
        this.toastr.success(`تمت إضافة ${this.product.name} إلى السلة.`);
      }

    } else {
      if (this.currentLang === 'en') {
        this.toastr.error('Error adding item to the cart.');
      } else {
        this.toastr.error('خطأ في إضافة المنتج إلى السلة.');
      }


    }
  }

  navigateToProduct(productId: number): void {
    this.router.navigate(['/products', this.categoryId, 'item', productId]);
  }

  trackByFn(index: number, item: ItemModule): number {
    return item.inItemID;
  }

  hideAlert(): void {
    this.showAlert = false;
  }

  getitemsCategory(): void {
    this.itemService
      .getServiceCategory(1, this.categoryId, 'Default')
      .subscribe(
        (items) => {
          this.allproducts = items;
          // console.log('All products:', this.allproducts);
        },
        (error) => {
          console.error('Error fetching items:', error);
        }
      );
  }
}
